var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[(_vm.mappedField && _vm.mappedField.components)?_c(_vm.mappedField.components.edit,{tag:"component",attrs:{"data":_vm.mappedField,"fieldsData":_vm.fieldsData,"field":_vm.field,"selfTemplateId":_vm.selfTemplateId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }